export const state = () => ({
  menuBannerRecommendationList: [],
});
